// #COMPATIBILITY_MODE

import Store from '../store/index'
import axios from 'axios'
import _ from 'lodash'
import dialog from './nikan-dialog-plugin'
import { i18nInstance } from './localization'
import router from './router'
import { toastInstance } from './toast'
import $sc from './shortcut.collection.js'
import qs from 'querystring'
import { globalLogger } from './logger'
import Endpoints from '@nikan/endpoints'
import merge from 'lodash/merge'
import { isEmpty } from '~/statics/validators'

const CURRENT_CULTURE = 'fa'
const CURRENT_UI_CULTURE = 'fa'

function getCurrentContext() {
  return Store.getters['useraccount/currentUserDetails'] || {}
}
function getCurrentUser() {
  return getCurrentContext().user
}
function getWorkshop() {
  return getCurrentContext().workshopId
}
function getSalaryPeriod() {
  return getCurrentContext().salaryPeriodId
}
function getFiscalPeriod() {
  return getCurrentContext().fiscalId
  return Store.getters['app-context/getFiscalPeriod']
}
function getCompany() {
  return getCurrentContext().companyId
}
function getCustomerCode() {
  let reviewModeData = getCurrentContext().reviewModeData
  return `${getCurrentContext().customerCode}${reviewModeData ? '_review' : ''}`
}
function logoutUser() {
  Store.dispatch('useraccount/clearUser')
  router.push({ name: 'login' })
}
function redirectToLauncher() {
  router.push({ name: 'launcher' })
}
let currentUser = null

let axiosInstance = null
export const getAxios = () => {
  let latestUser = getCurrentUser()
  if (axiosInstance == null || (latestUser != null && currentUser !== latestUser)) {
    currentUser = latestUser

    const headers = {
    }

    //FISCAL and COMPANY must be out of above if section because after login it should selecte last fiscal and company that user worked
    headers['NIKAN_APP_FISCAL'] = getFiscalPeriod()
    headers['NIKAN_APP_COMPANY'] = getCompany()
    headers['NIKAN_APP_WORKSHOP'] = getWorkshop()
    headers['NIKAN_APP_SALARYPERIOD'] = getSalaryPeriod()

    axiosInstance = axios.create({
      headers
    })

    axiosInstance.interceptors.request.use((config) => {
      const CUSER = getCurrentUser()

      config.headers.CCODE = getCustomerCode()

      if (CUSER && CUSER.access_token)
        config.headers['Authorization'] = 'Bearer ' + CUSER.access_token
      else
        delete config.headers['Authorization']

      return config
    })

    axiosInstance.interceptors.response.use(
      (res) => {
        return res
      },
      async (err) => {
        const originalConfig = err.config

        if (originalConfig.url !== "/api/token" && err.response) {
          // Access Token was expired
          if (err.response.status === 403 && err.response.data.message && err.response.data.message.indexOf('refreshToken') > -1) {
            logoutUser()
            return
          }
          if (err.response.status === 401 && !originalConfig._retry) {
            originalConfig._retry = true

            try {
              let currentUser = getCurrentUser()
              if (!currentUser) {
                logoutUser()
                return
              }
              const rs = await fetchRefreshToken(currentUser.refresh_token)

              Store.dispatch('useraccount/applyDetails', { user: rs })
              originalConfig.headers['Authorization'] = 'Bearer ' + rs.access_token

              return axiosInstance(originalConfig)
            } catch (_error) {
              return Promise.reject(_error)
            }
          }
        }

        return Promise.reject(err)
      }
    )
  }

  return axiosInstance
}

const addCurrentLocaleToUrl = url => {
  let begins = '&'
  if (url.indexOf('?') === -1) {
    begins = '?'
  }

  url += begins + `culture=${CURRENT_CULTURE}&ui-culture=${CURRENT_UI_CULTURE}`

  return url
}
const decorateRequest = (request, url) => {
  let currentContext = getCurrentContext()
  const module = url.split('/')[3].toLowerCase()

  let contextValues = {
    fiscalPeriodId: currentContext.fiscalPeriodId,
    companyId: currentContext.companyId,
    customerId: currentContext.customerId,

    // only add workshopId & salaryPeriodId if request if for salary module and their value is not empty
    ...(module === 'salary' && !isEmpty(currentContext.workshopId) ? { workshopId: currentContext.workshopId } : {}),
    ...(module === 'salary' && !isEmpty(currentContext.salaryPeriodId) ? { salaryPeriodId: currentContext.salaryPeriodId } : {})
  }

  if (request instanceof FormData) {
    request.append('fiscalPeriodId', contextValues.fiscalPeriodId)
    request.append('companyId', contextValues.companyId)
    request.append('customerId', contextValues.customerId)

    if (module === 'salary' && !isEmpty(currentContext.workshopId))
      request.append('workshopId', currentContext.workshopId)

    if (module === 'salary' && !isEmpty(currentContext.salaryPeriodId))
      request.append('salaryPeriodId', currentContext.salaryPeriodId)

    return request
  } else {
    return _.merge(contextValues, request)
  }
}

const getErrorDetail = error => {
  const act = errorItem => {
    switch (errorItem.code) {
      case 'NotFound': return {
        title: i18nInstance.global.t('Errors.NotFound.title'),
        body: i18nInstance.global.t('Errors.NotFound.body')
      }
      case 'UnauthorizedAccess': return {
        title: i18nInstance.global.t('Errors.UnauthorizedAccess.title'),
        body: i18nInstance.global.t('Errors.UnauthorizedAccess.body')
      }
      case 'InvalidFiscalPeriod': return {
        title: i18nInstance.global.t('Errors.InvalidFiscalPeriod.title'),
        body: i18nInstance.global.t('Errors.InvalidFiscalPeriod.body')
      }
      case 'InvalidCompany': return {
        title: i18nInstance.global.t('Errors.InvalidCompany.title'),
        body: i18nInstance.global.t('Errors.InvalidCompany.body')
      }
      case 'InvalidCustomer': return {
        title: i18nInstance.global.t('Errors.InvalidCustomer.title'),
        body: i18nInstance.global.t('Errors.InvalidCustomer.body')
      }
      case 'OperationAccessViolation': return {
        title: i18nInstance.global.t('Errors.OperationAccessViolation.title'),
        body: i18nInstance.global.t('Errors.OperationAccessViolation.body', { operationClaimName: i18nInstance.global.t(`operationClaims.${_.head(errorItem.arguments).operationClaimName}`) })
      }
      case 'DataAccessViolation':
        let names = ''
        if (errorItem.arguments && errorItem.arguments.length) {
          names = errorItem.arguments.map(arg => i18nInstance.global.t('EntityTypes.' + arg.entityType)).join('<br/>')
        }

        return {
          title: i18nInstance.global.t('Errors.DataAccessViolation.title'),
          body: i18nInstance.global.t(`Errors.DataAccessViolation.body${(names.length ? '-withname' : '')}`, { names })
        }
      case 'HasDependent':
        let lines = []
        if (errorItem.arguments && errorItem.arguments.length) {
          lines = errorItem.arguments.map(x => `- ${i18nInstance.global.t(x)}`)
        }
        return {
          title: i18nInstance.global.t('Errors.HasDependent.title'),
          body: i18nInstance.global.t('Errors.HasDependent.body') + '<div class="mt-4">' + lines.join('<br/>') + '</div>'
        }
      case 'IdentityException': return {
        title: i18nInstance.global.t('Errors.IdentityException.title'),
        body: i18nInstance.global.t('Errors.IdentityException.body')
      }
      case 'AcceptWarningException': {
        let lines = []
        if (errorItem.arguments && errorItem.arguments.length) {
          lines = errorItem.arguments
        }

        return {
          title: i18nInstance.global.t('Errors.AcceptWarningException.title'),
          body: errorItem.description + '<br/>' + lines.join('<br/>')
        }
      }
      case 'ValidationException': {
        let lines = []
        if (errorItem.arguments && errorItem.arguments.length) {
          lines = errorItem.arguments.map(arg => arg.errorMessage)
        }

        return {
          title: i18nInstance.global.t('Errors.ValidationException.title'),
          body: i18nInstance.global.t('Errors.ValidationException.body', { description: lines.join('<br/>') })
        }
      }
      default: return {
        title: i18nInstance.global.t('Errors.GeneralError.title'),
        body: i18nInstance.global.t('Errors.GeneralError.body', errorItem)
      }
    }
  }

  if (Array.isArray(error.errors)) {
    if (error.errors.length > 1) {
      let items = []
      for (var i = 0; i < error.errors.length; i++) {
        let er = error.errors[i]
        let item = act(er)
        items.push(item)
      }

      let body = `<li>${items.map(x => x.body).join('</li><li>')}</li>`
      return {
        errorCode: error.error[i].code,
        title: null,
        body
      }
    } else if (error.errors.length === 1) {
      let res = act(error.errors[0])
      return {
        errorCode: error.errors[0].code,
        title: res.title,
        body: res.body
      }
    }
  }

  return {}
}

const isModernResponse = (result) => Object.getOwnPropertyNames(result).filter(x => x === 'succeeded').length === 1
const convertToOldSchema = result => {
  return {
    success: result.succeeded,
    data: result.object,
    errors: result.errors
  }
}
const isUserUnauthorizeError = (error) => error.errors.filter(x => x.code === 'UnauthorizedAccess').length > 0
const isLauncherError = (error) => error.errors.filter(x => x.code === 'launcherException').length > 0

const _get = (url, options) => {
  url = url || ''
  url = _.isString(url) ? url.trim() : (() => { throw new Error('url is not a string') })()
  url = addCurrentLocaleToUrl(url)

  return new Promise((resolve, reject) => {

    if (!options.ignoreCommercialAccess && !checkCommercialAccess(url))
      return reject({ data: { items: [] }, message: 'Access Denied!' })

    if (options.preventConcurrent && Store.getters['concurrentRequests/get'](url)) {
      let ex = {
        title: i18nInstance.global.t('msg.general-server-error.title'),
        success: false,
        message: i18nInstance.global.t('msg.too-many-request'),
        messageTypeCode: 1,
        messageType: 'error',
      }
      ex.promise = new Promise((resolve, reject) => {
        setTimeout(() => {
          console.log(url)
          toastInstance(ex.message, { type: 'error' })
          resolve(ex)
        }, 50)
      })
      reject(ex)
      return
    }

    getAxios().get(url)
      .then(response => {
        var rd = response.data

        if (rd == null) {
          let ex = {
            success: false,
            message: 'Response is undefined',
            messageTypeCode: 1,
            messageType: 'error'
          }
          throw ex
        } else {
          if (isModernResponse(rd)) {
            if (rd.succeeded === false) {
              throw rd
            } else {
              resolve(convertToOldSchema(rd))
            }
          } else {
            if (rd.success === false) {
              throw rd
            } else {
              resolve(rd)
            }
          }
        }
      })
      .catch(error => {
        let ex = {
          title: i18nInstance.global.t('msg.general-server-error.title'),
          success: false,
          message: error.message,
          messageTypeCode: 1,
          messageType: 'error',
          exception: error
        }

        let responseContent = isModernResponse(error) ? error : _.get(error, 'response.data')
        if (responseContent) {
          if (isModernResponse(responseContent)) {
            let isUserUnauthorize = isUserUnauthorizeError(responseContent)
            if (isUserUnauthorize) {
              logoutUser()
              return
            }

            let isLaunchRequied = isLauncherError(responseContent)
            if (isLaunchRequied) {
              redirectToLauncher()
              return
            }

            let { title, body } = getErrorDetail(responseContent)
            ex.title = title || ex.title
            ex.message = body.replace(/(?:\r\n|\r|\n)/g, '<br>')
          } else if (responseContent.success === true) {
            ex.message = responseContent.message
          }
        }

        if (!options.silent) {
          // show the error dialog box
          ex.promise = new Promise((resolve, reject) => {
            setTimeout(() => {
              dialog({
                title: ex.title,
                body: ex.message,
                type: ex.messageType
              }).then(res => resolve(res))
                .catch(error => reject(error))
            }, 50)
          })
        } else {
          ex.promise = Promise.resolve()
        }

        reject(ex)
      })
  })
}
const _post = (url, data, options) => {
  const doPromise = (resolve, reject) => {
    let config = {
      header: {
        'Content-Type': data instanceof FormData ? 'multipart/form-data' : 'application/json'
      },
      onUploadProgress: options.onUploadProgress || (() => { })
    }

    if (url.toLowerCase().indexOf('download/') > -1) {
      config.responseType = 'blob'
    }

    if (options.responseType) {
      config.responseType = options.responseType
    }

    if (!options.ignoreCommercialAccess && !checkCommercialAccess(url))
      return reject({ data: { items: [] }, message: 'Access Denied!' })


    if (options.preventConcurrent && Store.getters['concurrentRequests/get'](url)) {
      let ex = {
        title: i18nInstance.global.t('msg.general-server-error.title'),
        success: false,
        message: i18nInstance.global.t('msg.too-many-request'),
        messageTypeCode: 1,
        messageType: 'error',
      }
      ex.promise = new Promise((resolve, reject) => {
        setTimeout(() => {
          console.warn('Concurrent', url)
          toastInstance(ex.message, { type: 'error' })
          resolve(ex)
        }, 50)
      })
      reject(ex)
      return
    }

    Store.dispatch('concurrentRequests/add', url)

    getAxios().post(url, data, config)
      .then(response => {
        setTimeout(() => {
          Store.dispatch('concurrentRequests/remove', url)
        }, 500)

        var rd = response.data

        if (rd == null) {
          let ex = {
            success: false,
            message: 'Response is undefined',
            messageTypeCode: 1,
            messageType: 'error'
          }
          throw ex
        } else {
          if (url.toLowerCase().indexOf('download/') > -1 || url.toLowerCase().indexOf('export/') > -1 || options.responseType === 'blob') {
            resolve(response)
          } else if (isModernResponse(rd)) {
            if (rd.succeeded === false) {
              throw rd
            } else {
              resolve(convertToOldSchema(rd))
            }
          } else {
            if (rd.success === false) {
              if (rd.message)
                throw rd
            } else {
              resolve(rd)
            }
          }
        }
      })
      .catch(error => {
        setTimeout(() => {
          Store.dispatch('concurrentRequests/remove', url)
        }, 500)

        let ex = {
          title: i18nInstance.global.t('msg.general-server-error.title'),
          success: false,
          message: error.message,
          messageTypeCode: 1,
          messageType: 'error',
          exception: error
        }

        let responseContent = isModernResponse(error) ? error : _.get(error, 'response.data')
        if (responseContent) {
          if (isModernResponse(responseContent)) {
            let isUserUnauthorize = isUserUnauthorizeError(responseContent)
            if (isUserUnauthorize) {
              logoutUser()
              return
            }

            let isLaunchRequied = isLauncherError(responseContent)
            if (isLaunchRequied) {
              redirectToLauncher()
              return
            }

            let { errorCode, title, body } = getErrorDetail(responseContent)
            ex.errorCode = errorCode
            ex.title = title || ex.title
            ex.message = body.replace(/(?:\r\n|\r|\n)/g, '<br>')
          } else if (responseContent.success === true) {
            ex.message = responseContent.message
          }
        }

        if (ex.errorCode === 'AcceptWarningException' && !options.warningTurn) {//options.warningTurn for prevent loop
          ex.promise = new Promise((exResolve, exReject) => {
            setTimeout(() => {
              dialog({
                title: ex.title,
                body: ex.message,
                type: 'warning',
                buttons: [
                  {
                    title: i18nInstance.global.t('dialog.yes'),
                    shortcut: $sc.find('yes', 'dialog'),
                    isPrimary: true,
                    handle: (button, page, e) => {
                      options.warningTurn = true
                      options.resolve = resolve
                      options.reject = reject
                      data.checkWarning = false
                      _post(url, data, options)
                    },
                  },
                  {
                    title: i18nInstance.global.t('dialog.cancel'),
                    shortcut: $sc.find('cancel', 'dialog'),
                    isCancel: true,
                    handle: (button, page, e) => {
                      reject()
                    },
                  },
                ],
              })
            }, 50)
          })
          return
        }

        if (!options.silent) {
          // show the error dialog box
          ex.promise = new Promise((exResolve, exReject) => {
            setTimeout(() => {
              dialog({
                title: ex.title,
                body: ex.message,
                type: ex.messageType
              }).then(res => resolve(res))
                .catch(error => reject(error))
            }, 50)
          })
        } else {
          ex.promise = Promise.resolve()
        }

        reject(ex)
      })
  }
  if (options.warningTurn) {
    return doPromise(options.resolve, options.reject)
  }
  url = url || ''
  url = _.isString(url) ? url.trim() : (() => { throw new Error('url is not a string') })()
  url = addCurrentLocaleToUrl(url)

  data = data || {}
  data = (_.isObject(data) || Array.isArray(data)) ? data : (() => { throw new Error('data is not an object or array') })()
  data = decorateRequest(data, url)
  if (!data.hasOwnProperty('checkWarning') && options.checkWarning) {
    data.checkWarning = true
  }
  return new Promise((resolve, reject) => {
    doPromise(resolve, reject)
  })
}
const _validate = url => {
  url = (url || '').trim()
  if (url === '') {
    throw new Error('url is required')
  }
}
const _getAddress = endpoint => {
  if (!endpoint) {
    return ''
  }

  let address = _.isString(endpoint) ? endpoint : endpoint.address
  return address
}

const checkCommercialAccess = (url) => {
  const endpoint = Endpoints.getEndpointByUrl(url)
  const hasPermission = Store.getters['appContext/checkCommercialAccess']
  var commercialAccess = endpoint.commercialAccess ? endpoint.commercialAccess : url.split('/')[3].upperCaseFirstLetter()

  if (!hasPermission(commercialAccess)) {
    globalLogger.error(`Access Denied! ${commercialAccess} - ${url}`)
    return false
  }

  return true
}

const api = {
  get(endpoint, callback, options = { silent: false, preventConcurrent: true, ignoreCommercialAccess: false }) {
    let address = _getAddress(endpoint)
    _validate(address)

    if (options && typeof options.preventConcurrent === 'undefined')
      options.preventConcurrent = true

    var promise = _get(address, options)

    if (callback == null) {
      return promise
    } else {
      promise
        .then(response => callback(response))
        .catch(error => callback(error))
    }
  },
  post(endpoint, data, callback, _options) {
    let options = { silent: false, preventConcurrent: true, ignoreCommercialAccess: false, checkWarning: true }
    merge(options, _options)
    let address = _getAddress(endpoint)
    _validate(address)

    if (options && typeof options.preventConcurrent === 'undefined')
      options.preventConcurrent = true

    var promise = _post(address, data, options)

    if (callback == null) {
      return promise
    } else {
      promise
        .then(response => callback(response))
        .catch(error => callback(error))
    }
  }
}

export const fetchRefreshToken = (refreshToken) => {
  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  }
  return axiosInstance.post('/api/refresh-token', qs.stringify({
    refreshToken: refreshToken || getCurrentUser().refresh_token
  }), config)
    .then(result => {
      return result.data
    })

}

export const get = api.get
export const post = api.post
export default api
